import ResourceCollection from "./resource-collection";
import Picker from "./Picker";
import Resource from "./resource";

export default {
  Picker,
  Resource,
  ResourceCollection
};
